import ReviewCard from "../../components/cards/ReviewCard"

const reviews = [
  {
    reviewer: "Eleanor Preston",
    title: "Plenty of transporters",
    content:
      "Really appreciated the sheer AMOUNT of transporters on this site to choose from - they made the selection easy, and the communication a breeze. ",
    trustpilot: false,
    facebook: true,
    rating: "5",
  },
  {
    reviewer: "Ali Flihan Preston",
    title: "I really like CitizenShipper, they are amazing",
    content:
      "I really like CitizenShipper because i can ship anything by them and its easy to use. I shipped my Jetski from Kansas to Iowa. I would use them again and again for anything i want to ship.",
    trustpilot: true,
    facebook: false,
    rating: "5",
  },
  {
    reviewer: "Nick Deleasio",
    title: "Trusted pet transport",
    content:
      "Whitney was amazing! Very friendly, she arrived promptly and provided updates & pictures along the way; we felt very comfortable knowing she took great care of our puppy! Beyond happy and I totally recommend her!",
    trustpilot: false,
    facebook: true,
    rating: "5",
  },
  {
    reviewer: "Charlene Carmel",
    title: "Will be recommending CitizenShipper!",
    content:
      "Love Citizenshipper! They do a fantastic job in weeding out great trustworthy drivers for your precious cargo. I have recommended them several times already. It's a very fast and efficient process. Thanks again!",
    trustpilot: false,
    facebook: true,
    rating: "5",
  },
]

export default function ItemTransportReviews() {
  return (
    <section className="relative w-full page-padding grid grid-cols-1 md:grid-cols-2 gap-8">
      <h3 className="mb-3 font-montserrat font-semibold text-3xl text-center col-span-full">
        100,000+ precious items safely transported
      </h3>
      {reviews.map((review, i) => (
        <ReviewCard
          review={review}
          key={`itemTransportReviews/ReviewCard/${i}`}
        />
      ))}
    </section>
  )
}
